export default __webpack_public_path__ + "static/media/remove.759eea53.svg";